import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc75e75a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-12 flex text-capDarkPurple" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-semibold text-3xl" }, "Contracts")
], -1))
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" View Details ")

import SharedAPI from '@/api/SharedAPI'
    import { useCurrency } from '@/composables/useCurrency'
    import { computed, onMounted, ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from 'vuex'

    type Contract = {
        __kptID: string | number
        contractNumberDisplay: string
        zctWebAddrLine1: string
        physicalAddrCity: string
        physicalAddrState: string
        physicalAddrPostalCode: string
        planName: string
        planPriceExtended: number | string
        status: string
    } & Record<string, unknown>

    // FileMaker's exact spelling isn't confirmed, so both variants are matched defensively.
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Contracts',
  setup(__props) {

    const DEMOTED_STATUSES = ['Cancelled', 'Canceled', 'Denied']

    const isLoading = ref<boolean>(true)
    const contracts = ref<Contract[]>([])
    const listItems = ref<Contract[]>([])
    const filteredListItems = ref<Contract[]>([])

    const store = useStore();
    const router = useRouter()
    const user = computed(() => store.state.user)

    onMounted(() => {
        getContracts()
    })

    async function getContracts(): Promise<void> {
        try {
            const params = [
                { _kftContactID: user.value.kptID },
                { status: 'Deleted', omit: 'true'}
            ]
            const res = await SharedAPI.performFind(params, 'contract')
            res.response.data.forEach((contract: { fieldData: Contract }) => {
                contracts.value.push(contract.fieldData)
            })
            // Stable sort: demoted statuses sink to the bottom, original order preserved otherwise.
            contracts.value.sort((a, b) =>
                (DEMOTED_STATUSES.includes(a.status) ? 1 : 0) - (DEMOTED_STATUSES.includes(b.status) ? 1 : 0)
            )
            listItems.value = contracts.value
            filteredListItems.value = contracts.value
        }
        catch (error: any) {
            console.error(error)
        }
        finally {
            isLoading.value = false
        }
    }

    function routeToDetailPage(id: string | number): void {
        router.push({ name: 'ContractDetail', params: { id } })
    }

    const defaultCurrency = computed(() =>
        user.value?.currencyCode ??
        (user.value?.country === 'CA' ? 'CAD' : 'USD')
    )

    const defaultLocale = computed(() =>
        user.value?.locale ?? (defaultCurrency.value === 'CAD' ? 'en-CA' : 'en-US')
    )

    const { formatMoney } = useCurrency({
        defaultCurrency: defaultCurrency.value,
        locale: defaultLocale.value
    })

return (_ctx: any,_cache: any) => {
  const _component_loading = _resolveComponent("loading")!
  const _component_c_badge = _resolveComponent("c-badge")!
  const _component_c_container_heading = _resolveComponent("c-container-heading")!
  const _component_c_container_text = _resolveComponent("c-container-text")!
  const _component_c_button = _resolveComponent("c-button")!
  const _component_c_container = _resolveComponent("c-container")!

  return (isLoading.value)
    ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredListItems.value, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item + ' + ' + index
            }, [
              _createVNode(_component_c_container, {
                status: item.status
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_c_badge, {
                      status: item.status,
                      class: "float-right"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.status), 1)
                      ]),
                      _: 2
                    }, 1032, ["status"]),
                    _createVNode(_component_c_container_heading, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.contractNumberDisplay), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_c_container_text, { secondary: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.zctWebAddrLine1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_c_container_text, { secondary: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.physicalAddrCity + ", " + item.physicalAddrState + " " +
                            item.physicalAddrPostalCode), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_c_container_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.planName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_c_container_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatMoney)(item.planPriceExtended)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createVNode(_component_c_button, {
                    onClick: ($event: any) => (routeToDetailPage(item.__kptID))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["status"])
            ]))
          }), 128))
        ])
      ], 64))
}
}

})